import { siteConfig } from "../config/site";

const ICONS = {
  instagram: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  ),
  tiktok: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.87a8.16 8.16 0 0 0 4.77 1.52V7a4.85 4.85 0 0 1-1.84-.31z"/>
    </svg>
  ),
  youtube: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.6 3.6 12 3.6 12 3.6s-7.6 0-9.4.5A3 3 0 0 0 .5 6.2C0 8 0 12 0 12s0 4 .5 5.8A3 3 0 0 0 2.6 19.9c1.8.5 9.4.5 9.4.5s7.6 0 9.4-.5a3 3 0 0 0 2.1-2.1C24 16 24 12 24 12s0-4-.5-5.8zM9.6 15.6V8.4L15.8 12l-6.2 3.6z"/>
    </svg>
  ),
  link: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
};

const ITEMS = [
  { key: "instagram", label: "Instagram", color: "from-[#FFD1D1] to-[#FFDFD3]" },
  { key: "tiktok",    label: "TikTok",    color: "from-[#B9E0FF] to-[#B2A4FF]" },
  { key: "youtube",   label: "YouTube",   color: "from-[#FFDFD3] to-[#FFD1D1]" },
  { key: "linkInBio", label: "Link in Bio", color: "from-[#B2A4FF] to-[#B9E0FF]", icon: "link" },
];

export default function SocialSection() {
  const { social } = siteConfig;
  return (
    <section id="social" data-testid="social-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-[0.7rem] tracking-[0.35em] uppercase text-[color:var(--yicel-violet)] font-semibold">
            Encuéntrame
          </span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl text-ink">
            Sígueme el paso
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 max-w-5xl mx-auto">
          {ITEMS.map((it) => (
            <a
              key={it.key}
              href={social[it.key] || "#"}
              target="_blank"
              rel="noreferrer"
              data-testid={`social-${it.key}`}
              className="group relative overflow-hidden rounded-3xl p-6 sm:p-8 bg-white/60 backdrop-blur-md border border-white/70 hover:border-transparent transition-all duration-500"
            >
              <div
                className={`absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-br ${it.color}`}
              />
              <div className="relative flex flex-col items-start gap-4">
                <div className="h-12 w-12 rounded-2xl bg-white/80 flex items-center justify-center text-ink group-hover:bg-white transition">
                  {ICONS[it.icon || it.key]}
                </div>
                <div>
                  <p className="font-display text-xl text-ink">{it.label}</p>
                  <p className="mt-1 text-xs tracking-[0.2em] uppercase text-[color:var(--yicel-muted)]">
                    Seguir →
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
